export const PAGINATION = Object.freeze({
  DEFAULT_LIMIT: 20,
})
export const SORT_ORDER = Object.freeze({
  ASC: 'asc',
  DESC: 'desc',
  SELECTED: 'selected',
  FAVORITES: 'favorites',
})
